var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KTPortlet',{scopedSlots:_vm._u([{key:"toolbar",fn:function(){return undefined},proxy:true},{key:"body",fn:function(){return [_c('tagProcessor',{attrs:{"id":_vm.$route.params.id}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }